import type { ButtonHTMLAttributes } from 'react';
import { buttonClassName, type ButtonSize, type ButtonVariant } from './buttonClassName';

/**
 * The console's one button (design book: Drift 4). `brand` is the crimson fill the book
 * keeps for the error-state "Try again"; everything else uses the near-black primary.
 */
interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: ButtonVariant;
  /** `sm` for dense rows and tables (payments, settings); `md` everywhere else. */
  size?: ButtonSize;
  /** A request is in flight: disabled and announced as busy, so a second click never submits twice. */
  busy?: boolean;
}

export function Button({
  variant,
  size = 'md',
  busy = false,
  type = 'button',
  className,
  disabled,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      type={type}
      className={
        className
          ? `${buttonClassName(variant, size)} ${className}`
          : buttonClassName(variant, size)
      }
      disabled={disabled || busy}
      aria-busy={busy || undefined}
    />
  );
}
